<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div>
  <div fxLayout="column" *ngIf="!isImageArray">
    <div *ngFor="let item of arrayItem.value; let i = index">
      <div [ngSwitch]="item.type">
        <div *ngSwitchCase="TaskDatumType.STRING">
          <app-string-item [stringItem]="item"></app-string-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.TIMESTAMP_ISO">
          <app-timestamp-item [timestampItem]="item"></app-timestamp-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.BOOL">
          <app-boolean-item [booleanItem]="item"></app-boolean-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.INT">
          <app-int-item [intItem]="item"></app-int-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.DOUBLE">
          <app-double-item [doubleItem]="item"></app-double-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.ARRAY">
          <app-array-item [arrayItem]="item.value"></app-array-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.BARCODE">
          <app-barcode-item [barcodeItem]="item.value"></app-barcode-item>
        </div>
        <div *ngSwitchCase="TaskDatumType.SIGNATURE">
          <app-signature-item [signatureItem]="item.value"></app-signature-item>
        </div>

        <div *ngSwitchCase="TaskDatumType.OBJECT">
          <app-object-item [objectItem]="item"></app-object-item>
        </div>
        <div *ngSwitchDefault fxLayout="column">
          <span>item not yet implemented : </span>
          <span>type : {{ item.type }}</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="images.length > 0">
    <app-image-slider
      [images]="images"
      *ngIf="isImageArray"
      [displayBorder]="true"
      [imageSize]="{ width: 200, height: 80 }"
      (imageClick)="onImageClick(images)"
      (lightboxClose)="onLightBoxClose(images)"
    ></app-image-slider>
  </div>
</div>
